import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { useProductPageContext } from "shared/product/ProductPageContext/useProductPageContext";
import { Button } from "ui/Button";
import { StrapiImage } from "ui/StrapiImage";
import { useI18n } from "utils/with-i18n.utils";

import { TipsList } from "./TipsList";


export const TipsSection = () => {
  const i18n = useI18n();
  const familySlug = useRouter().query.slug;
  const { currentVariant, family } = useProductPageContext();
  const [isOpen, setIsOpen] = useState<boolean>();

  useEffect(() => {
    setIsOpen(false); // We don't set true by default in the declaration of usestate because we need to show the content to SEO robots
  }, []);

  return (
    <section className="px-5 mx-auto w-full">
      <div className="flex flex-col gap-3 items-center px-5 pt-10 mx-auto mt-24 mb-5 max-w-1110 bg-[#F9F7F2] rounded-lg border border-black/10">
        <h2 className="text-2xl font-bold text-center md:text-3xl">
          {i18n.t("product.tips.title", {
            modelName: i18n.addDeviceDefiniteArtcile({
              model: family.modelName || "",
              brand: family.brand || "",
            }),
          })}
        </h2>
        <p className="text-center md:text-lg">
          {i18n.t("product.tips.subtitle")}
        </p>

        <Button onClick={() => setIsOpen(!isOpen)} alternative="white" className="mt-3">
          {i18n.t(isOpen ? "product.tips.seeLess" : "product.tips.seeMore")}
        </Button>

        {(isOpen || isOpen === undefined) && (
          <div className="mt-3 w-full max-w-xl">
            <TipsList
              familyCategories={family.tips || []}
              familySlug={familySlug as string}
            />
          </div>
        )}

        <div className="overflow-y-hidden mt-5">
          <div className="-mb-[175px] w-[320px] h-[320px] ">
            <StrapiImage
              image={currentVariant?.combinedPicture ?? undefined}
              size="small"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
